import React, { useState } from "react";
import ThemeMaker from "../../components/thememaker";
import VetClinicServices from "./vetClinicServices";
import ServiceProcedure from "./ServiceProcedure";
import TreatmentPlan from "./TreatmentPlan";
import LabTest from "./LabTest";

const VetClinicManagementTabs = ({ fromSetup = false }) => {
  const [activeTab, setActiveTab] = useState("service");

  
  const tabs = [
    {
      id: "service",
      label: "Vet Clinic Services",
      component: <VetClinicServices fromSetup={fromSetup} />,
    },
    {
      id: "procedure",
      label: "Service Procedures",
      component: <ServiceProcedure />,
    },
    { id: "treatment", label: "Treatment Plans", component: <TreatmentPlan /> },
    { id: "labtest", label: "Lab Tests", component: <LabTest /> },
  ];

  return (
    <ThemeMaker>
      <div className="p-4">
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                  ${
                    activeTab === tab.id
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-4">
          {tabs.find((tab) => tab.id === activeTab)?.component}
        </div>
      </div>
    </ThemeMaker>
  );
};

export default VetClinicManagementTabs;